module.exports = __webpack_public_path__ + "static/media/politics.47a17c65.jpg";